// src/lib/queryClient.ts
import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,        // 5 min – data is "fresh" for this window
      gcTime: 10 * 60 * 1000,           // 10 min – keep unused cache entries
      retry: 1,
      refetchOnWindowFocus: false,      // avoid refetches on tab switch
    },
  },
});
